import React from 'react';
import cn from 'classnames';
import Input from '../Input/Input';
import styles from './SearchField.module.css';

export default ({ className = '', ...rest }) => (
    <Input {...rest} className={cn(styles.input, className)} autoComplete="off" />
);
